export enum HashtagsModeEnum {
  NORMAL = 'NORMAL',
  COMPACT = 'COMPACT'
}
